<template>
  <section class="section pt-5">
    <div class="container">
      <!-- Encabezado -->
      <div class="level mb-5">
        <div class="level-left">
          <div class="level-item">
            <div>
              <h1 class="title">{{ $t("category_management") }}</h1>
              <p class="subtitle">{{ $t("manage_ticket_categories") }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- DataTable de categorías -->
      <categories-datatable />
    </div>
  </section>
</template>

<script>
import CategoriesDataTable from "./categories_datatable/Index.vue";

export default {
  name: "HelpdeskCategories",
  components: {
    "categories-datatable": CategoriesDataTable,
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
